module.exports = __webpack_public_path__ + "static/media/footbal_icon.0b455dd7.svg";